"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePremiumSupport = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var useLiveChatVisibility_1 = require("../useLiveChatVisibility");
var usePremiumSupport = function () {
    var manager = (0, swr_hooks_1.useManager)().data;
    var openManager = (0, apps_shared_1.useOpenModal)(apps_shared_1.POPUP_CONSTANTS.PERSONAL_MANAGER);
    var openLiveChatModal = (0, useLiveChatVisibility_1.useLiveChatVisibility)();
    var openManagerHandler = (0, react_1.useCallback)(function () {
        if (manager)
            openManager();
        else
            openLiveChatModal();
    }, [manager, openManager, openLiveChatModal]);
    return (0, react_1.useMemo)(function () { return ({ manager: manager, openManager: openManagerHandler }); }, [manager, openManagerHandler]);
};
exports.usePremiumSupport = usePremiumSupport;
